import { NgModule } from "@angular/core";
import { Subject } from 'rxjs'

@NgModule()
export class Events {

    windowSize: Subject<boolean> = new Subject<boolean>();

    constructor(){}
}